<template>
    <div class="lg:w-[90%] md:w-[calc(100vw-380px)] sm:w-[calc(100vw-300px)]" v-if="!singleNotification">

        <div class="flex items-center py-5 !px-10">
            <v-badge overlap bordered :content="getUnreadNotifications" :value="getUnreadNotifications"
                :color="colorAsRoute" class="text_color_custom " dark bottom>
                <Icon icon="mdi:bell-ring-outline" class="!text-4xl" :color="colorAsRoute" />

            </v-badge>
            <v-card-title :class="`${routeLink}_fortext !text-3xl !font-semibold`">Notifications</v-card-title>
        </div>

        <div class="">
            <div>
                <div class=" overflow-y-auto sm:h-[calc(100vh-110px)] h-[calc(100vh-200px)]   !rounded-br-[30px]">
                    <LoadingSpinner v-if="notificationsLoading"
                        class="bg-transparent !relative !top-1/2 -translate-y-1/2" />
                    <v-list-item dark
                        class="mb-5 py-4 mx-4 justify-center !max-h-[80px] gray rounded-xl black red_list font-Handel text-center !px-10"
                        v-else-if="notifications.length < 1">
                        No Notifications Available
                    </v-list-item>
                    <v-list v-else class="text-white transparent font-Handel !px-10 !py-4">
                        <v-list-item dark v-for="(notification , idx) in notifications" :key="notification.nid" :to="{
                            name: 'SingleNotification',
                            params: { id: notification.nid },
                        }"
                        v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
                            opacity: 1, y: 0, transition: {
                              duration: 400,
                              type: 'keyframes',
                              ease: 'backInOut',
                              delay: `${idx}00`,
                            },
                          }"
                            :class="`mb-5 ${notification.read_at == null ? `${routeLink}_box-shadow` : ''} premium_user_list !border-[1px] !border-gray-400 rounded-3xl before:!opacity-0 before:rounded-3xl`">
                            <!-- :class="`${notification.read_at == null ? `${routeLink}_box-shadow` : ''}`" -->
                            <!-- this will be used when notification read will work -->
                            <v-list-item-icon class="mr-3">
                                <v-avatar size="50">
                                    <v-img class="!border-2 " position="top center" :class="`${routeLink}-border`"
                                        :src="`${notification.data.user_image}`" alt="" />
                                </v-avatar>
                            </v-list-item-icon>

                            <v-list-item-content class="">
                                <v-list-item-title class="">
                                    {{ notification.data.subject }}</v-list-item-title>
                                <v-list-item-subtitle class="">{{
                                    notification.data.message
                                }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-content class="!absolute top-0 right-5">
                                <span :class="`text-xs ${routeLink}_fortext` ">{{ notification.time }}</span>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </div>
            </div>
        </div>
    </div>
    <PremiumSingleNotification v-else />

</template>

<script>
import LoadingSpinner from '@/pages/front/straight/childs/LoadingSpinner.vue';
import { Icon } from '@iconify/vue2';
import axios from 'axios';
import PremiumSingleNotification from './PremiumSingleNotification.vue';

export default {
    components: {
        Icon,
        LoadingSpinner,
        PremiumSingleNotification
    },
    data() {
        return {
            notifications: [],
            notificationsLoading: false,
            singleNotification: true

        };
    },
    methods: {
        async getNotifications() {
            try {
                this.notificationsLoading = true;
                const resp = await axios.get('user-notifications')
                // console.log(JSON.parse(resp.data.data[0].data))
                this.notifications = resp.data.data
                console.log(this.notifications)

                this.notifications.map((i) => { const data = JSON.parse(i.data); i.data = data; i.date = new Date(i.created_at).toLocaleDateString(); i.time = new Date(i.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) })

                // console.log(resp.data.data)
            } catch (error) {
                console.log(error, "~from premium notification")
            } finally {
                this.notificationsLoading = false;
            }
        }
    },
    computed: {
        getUnreadNotifications() {
            return this.$store.getters.unreadNotification
        },
        colorAsRoute() {
            if (this.routeLink == "straight") {
                return "#a07a1d";
            }
            else if (this.routeLink == "gay") {
                return "#88c3fa";
            }
            else if (this.routeLink == "lesbian") {
                return "#9e2eec";
            }
        },
    },
    created() {
        this.$store.dispatch('messagesHandler')
        this.getNotifications();
    },
    watch: {
        '$route.params.id': {
            handler: function (id) {
                if (id) {
                    this.singleNotification = true;
                } else {
                    this.singleNotification = false;
                }
            },
            immediate: true,
            deep: true

        }
    }



}

</script>
<style scoped>
.logo {
    width: 30%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 30px;
    margin-bottom: 30px;
}

.timeFloater {
    position: absolute;
    top: 5%;
    right: 2%;
}

.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_centerGradient {

    background: rgb(59, 0, 68);
    background: linear-gradient(163deg, rgb(37 0 42) 0%, rgb(87 1 133) 38%, rgba(130, 5, 197, 1) 100%);
    position: relative;
    z-index: 1;

}

.gay_centerGradient {
    background: rgb(1, 2, 4);
    background: -moz-linear-gradient(174deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    background: -webkit-linear-gradient(174deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    background: linear-gradient(174deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#009bff", GradientType=1);
}

.straight_centerGradient {

    background: rgb(1, 2, 4);
    background: -moz-linear-gradient(171deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    background: -webkit-linear-gradient(171deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    background: linear-gradient(171deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#837045", GradientType=1);

}

.lesbian_sideGradient {

    background: rgb(59, 0, 68);
    background: linear-gradient(90deg, rgb(37 0 42) 0%, rgb(87 1 133) 38%, rgba(130, 5, 197, 1) 100%);
    position: relative;
    z-index: 1;

}

.gay_sideGradient {
    background: rgb(1, 2, 4);
    background: -moz-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    background: linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#009bff", GradientType=1);
}

.straight_sideGradient {

    background: rgb(1, 2, 4);
    background: -moz-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    background: linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#837045", GradientType=1);

}

.straight-border {
    border-color: #a07a1d;
}

.gay-border {
    border-color: #88c3fa;
}

.lesbian-border {
    border-color: #9e2eec;
}

.straight_box-shadow {
    border-color: #da930f !important;
    box-shadow: 0px 0px 10px 0px #b38123 !important;
    border-radius: 25px;

}

.lesbian_box-shadow {
    border-color: #9120d1 !important;
    box-shadow: 0px 0px 10px 0px #9120d1a6 !important;
    border-radius: 25px;

}

.gay_box-shadow {
    border-color: #00b2ff !important;
    box-shadow: 0px 0px 10px 0px #00b5ff !important;
    border-radius: 25px;
}

.text_color_custom:deep(.v-badge__badge) {
    color: black;
}
</style>
